import { useRouter } from 'next/router';
import { LegalDocumentVersion, LegalDocumentVersions } from '@/website/util/legal';
import { useLocalTranslation } from '@jove-frontend/uikit';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

interface LegalVersionSwitcherProps {
  documentVersions: LegalDocumentVersions;
}

export const versionLabelKeys: Record<LegalDocumentVersion, string> = {
  GB: 'page:legalDocument.version_united_kingdom',
  EU: 'page:legalDocument.version_european_union',
  US: 'page:legalDocument.version_united_states',
};

export default function LegalVersionSwitcher(props: LegalVersionSwitcherProps): JSX.Element {
  const { documentVersions } = props;

  /**
   * state
   */
  const router = useRouter();
  const { $t } = useLocalTranslation();

  /**
   * methods
   */
  const switchVersionAction = (version: LegalDocumentVersion | null) => {
    if (!version || version === documentVersions.active) return;
    const basePath = router.asPath.split('?')[0].split('#')[0];
    // Use ?version= (not ?country=) so the legal template switch never collides with
    // the site-wide country preference consumed by middleware and AppContext.
    router.push(`${basePath}?version=${version}`);
  };

  return (
    <Box className="mt-6">
      <ToggleButtonGroup exclusive value={documentVersions.active} onChange={(_event, version) => switchVersionAction(version)} className="flex-wrap">
        {documentVersions.options.map((version) => (
          <ToggleButton
            key={version}
            value={version}
            className="border-grey-10 text-gray-dark [&.Mui-selected]:bg-brand-primary [&.Mui-selected]:hover:bg-brand-primary min-h-[44px] px-3 text-sm font-semibold normal-case md:px-5 [&.Mui-selected]:text-white"
          >
            {$t(versionLabelKeys[version])}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
